import createSelector from 'selectorator'
import { identity, path } from 'ramda'
import { RootState } from 'src/state/types'
import { NAMESPACE } from './constants'
import { TBankingPartyErrors, TBankingState } from './types'

/**
 * Get a slice of the banking API state
 * EG: getSlice('byId')
 *
 * @param key Banking API state object key
 */
export const getSlice = <K extends keyof TBankingState>(key: K) =>
  createSelector<RootState, TBankingState[K]>([`api.${NAMESPACE}.${key}`], identity)

export const getById = getSlice('byId')

/**
 * Get the banking errors recorded against a party, or `undefined` when the party has never
 * been validated. `null` means validation is in flight.
 */
export const getBankingPartyById = createSelector<RootState, (id: string) => TBankingPartyErrors | null | undefined>(
  [getById],
  byId => id => path([id], byId),
)
